'use strict';

import type { IpList } from '../Entities/IpList';
import { EntityCollection } from './EntityCollection';

export class IpListCollection extends EntityCollection<IpList> {}
